/**
 * Класс для описания ajax форм
 */

/* global $ */
/* global _ */

'use strict';

import { getAjax } from '../utils/ajax';
import { fancybox } from '../utils/params';
import * as Targets  from './targets';

/**
 * Функция для установки получения ajax форм по кликам на указанные ссылки
 * @param {Object} options объект с указанием массива триггеров и дополнительный параметров
 *        triggers - массив селекторов для установки триггеров. У триггеров должны быть определены data атрибуты data-form-id (id формы) или data-form-name - имя класса формы
 *        windowOpt - опции окна fancybox
 */
function FormsTriggers(options){

    var opt = $.extend(true, {  triggers: [],
                                windowOpt: {
                                    maxWidth: 800,
                                    // minWidth: 500,
                                    fitToView: true,
                                    padding: [20,20,20,20],
                                }
                              }, options);

    if(opt.triggers.length>0){
        var i = 0;
        while(i<opt.triggers.length){
            var $el = $(opt.triggers[i]);
            var j = 0;
            while(j<$el.length){
                var $item = $el.eq(j);
                var can_init = false;
                var p = {
                    afterSend: function(){
                        $.fancybox.hideLoading();
                        $.fancybox.update();
                    },
                    beforeSend: function(){
                        $.fancybox.showLoading();
                    },
                    params: {}
                };
                var data = $item.data();
                for (var key in data) {
                    switch(key){
                    case 'form_id':
                        can_init = true;
                        break;
                    case 'form_name':
                        can_init = true;
                        break;
                    }
                    p.params[key] = data[key];
                }
                if(can_init){
                    $item.get(0).__form = new Form(p);
                    $item.on('click', function(e){
                        e.preventDefault();
                        $.fancybox.showLoading();
                        var proxy = $.proxy(function(form){
                            if(form.content){
                                $.fancybox.hideLoading();
                                $.fancybox($.extend(true, {},
                                    fancybox,
                                    opt.windowOpt,
                                    {
                                        content: form.content,
                                    })
                                );
                                var selector = '.fancybox-inner';
                                if(opt.wrapCSS){
                                    selector = '.'+opt.wrapCSS+' '+selector;
                                }
                                this.__form.init($(selector));
                                // $(selector+" .popup-close").on("click", function(){ $.fancybox.close(); });
                            }
                        }, this);
                        this.__form.get(proxy);
                    });
                }
                j++;
            }

            i++;
        }
    }
}

/**
  * Класс для работы с формами.
  * @param {jQuery} dom - объект, в которые нужно вставить формы
  * @param {String} form_name - имя формы
  * @param {Function} callback - функция, куда передается результат
  */
class Form{
    constructor(options){
        let opt = $.extend(true, {}, options);

        for(let key in opt){
            this[key] = opt[key];
        }


        this.cache = {};
    }
    get(callback){
        let self = this;

        if((!self.cache.content)||(self.cache.content == 'error')){
            self.cache = { };
            let can_get = false;
            let p = $.extend(true, { _do: 'get_form' }, self.params);

            if(p.form_id){
                // p.form_id = self.params.form_id;
                can_get = true;
            }else if(p.form_name){
                // p.form_name = self.form_name;
                can_get = true;
            }
            if(can_get){
                getAjax(p)
                .then(function(response){
                    if(response.data){
                        self.cache.content = response.data.content;
                        self.cache.object_id = response.data.object_id;
                        self.cache.object_name = response.data.object_name;
                        if(callback){
                            callback(self.cache);
                        }
                        if(self.dom){
                            self.add(self.dom);
                        }
                    }

                });
            }
        }else{
            if(callback){
                callback(self.cache);
            }
            if(self.dom){
                self.add(self.dom);
            }
        }
    }
    add(dom){
        var self = this;
        dom.html(self.cache.content);
        self.init(dom);
    }

    init(dom){
        var self = this;

        self.form = dom.find('.form form');
        var submit = self.form.get(0).onsubmit || function() { };

        self.target_method = self.form.data('method') || null;
        if((self.target_method) && (typeof Targets !== 'undefined')){
            Targets.set(self.target_method);
        }

        self.form.submit(function(e){
            e.preventDefault();
            self.precheck();
            submit();
        });
    }

    answer(json){
        var self = this;
        if(json.status == 'ok'){

            if(self.target_method){
                self.form.trigger(self.target_method);
            }

            self.form.parent().html(json.content);
            if(self.afterSend){
                self.afterSend();
            }
        }else{
            if(json.errors){
                for(var i=0;i<json.errors.length;i++){
                    var attr = '.attr-'+json.errors[i];
                    self.form.find(attr).addClass('m--error');
                }
            }
            if(self.afterSend){
                self.afterSend();
            }
        }
    }
    precheck(){
        var self = this;
        if(self.form){

            if(self.beforeSend){
                self.beforeSend();
            }

            self.form.find('.m--error').removeClass('m--error');
            var params = self.form.serializeArray();

            getAjax(params,
                { _do: 'submit_form' })
                .then(function(response){
                    if(response.data){
                        self.answer(response.data);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
}

export {
    FormsTriggers
};

